import React from 'react';
import { connect } from 'react-redux';

import CancelSubscriptionButton from './CancelSubscriptionButton';

import { cancelActiveSub } from '../../redux/auth/user/actions';
import { selectSubscriptionIsCanceled, selectSubscriptionPeriodEnd } from '../../redux/auth/billing/selectors';
import { selectIsUserStandard, selectPlan } from '../../redux/auth/user/selectors';

const CancelSubscriptionButtonConnected = (props) => <CancelSubscriptionButton {...props} />;

const mapStateToProps = (state) => ({
  isCanceled: selectSubscriptionIsCanceled(state),
  isUserStandard: selectIsUserStandard(state),
  subscriptionPeriodEnd: selectSubscriptionPeriodEnd(state),
  plan: selectPlan(state),
});

const mapActionsToProps = {
  cancelActiveSub,
};

export default connect(mapStateToProps, mapActionsToProps)(CancelSubscriptionButtonConnected);
